import * as catalogos from './catalogos/en';
export const locale = {
  lang: 'en',
  data: {
    'RESPONDE': catalogos.answer,
    'CONSULTATABLA': {
      'TITULO': 'General data',
      'HEADER': 'Companies',
      'BUSCAR': 'Search company',
      'BUSCAR_PLACEH': 'Enter the name of the company you want to search',
      'EMPRESA': 'Company',
      'MESSAGE3':'<span> If you are sure you want to make a logical deletion of the product, enter the text in red in the text box:',
      'MESSAGE4':'</span>',
      'CANCELAR': 'Cancel',
      'COMFIR': 'Confirm',
      'PROC_DELE_PROD':'Eliminating product',
      'SUCC_DELE_PROD':'Product was successfully removed',
      'DELE_PRODU':'Delete product',
      'TEX_VERS_RESULT_OPC1':'Default version',
      'TEX_VERS_RESULT_OPC2':'Custom version',
      'TEX_VERS_RESULT_LAB':'Custom version',
      'TEX_PLAC_RESULT_LAB':'Enter custom version',
      'TEX_MOD_RESULT_VERS':'You need to enter the result version type',
      'TIPO_EMPRESA':{
        '1':'Cultural Go',
        '2':'Cultural Go express',
        '3':'Cultural Go swift',
      },
      'ACCION': 'Actions',
      'CREAT_DATE_EMP':'Date of creation',
      'TYP_REGISTR_EMP':'Type of registration',
      'AUTOR_EMP':'Author',
      'SELECT_PLANTILLA': 'Please select a template',
      'SELECT_EMAIL_PLANTILLA': 'Please select an e-mail template',
      'DETALLE': 'Products',
      'MANAGER_TI': 'Manager of IT',
      'STATUS':'Survey status',
      'EMA_HISTO':'Mail History',
      'LABEL1': 'Company data',
      'DESCDETAIL': 'Angular reactive forms fac flowing between a non-UI data model (typically retrieved from a server) and a UI-oriented form model that retains the states and values of the HTML controls on screen. Reactive forms offer the ease of using reactive patterns, testing, and validation',
      'DETAIL': 'Detail',
      'SECTOR': 'Sector',
      'SUBSECTOR': 'Sub-sector',
      'RANKING': 'Ranking',
      'TIPO': 'Type',
      '0': 'White Icon Design',
      '1': 'Yellow Icon Design',
      '4': 'Icon Design Circles',
      'Reactivos': 'Statements',
      'NPS': 'Overarching statement',
      'Demograficos': 'Demographic',
      'Forall': 'For All',
      'Adicionales': 'Additional statements',
      'Control': 'Control',
      'Abiertas': 'Open questions',
      'URL':'Link',

      'SELECCIONE_FECHA': 'List year',
      'SELECT_CSSID': 'Year of application',
      'SELECT_CSSIDR': 'Year of ranking',
      'TIPORANKING': 'Ranking type ',
      'TIP_PRODU': 'Product type',
      'TIP_PLAN_PRO': 'Template name',
      'TIP_DIS_PRO': 'Design',
      'SELECT_CSSID2': 'Select a survey design',
      'SELECT_RESULTS': 'Selecciona un producto',
      'SURVEYTK_TITU': 'Survey token',
      'SURVEYTK_DESC': 'Enter the Survey Token for this product',
      'TABLEAUVER_TITU': 'Results version',
      'TABLEAUVER_DESC': 'Enter the results system version for this product',
      'IDOPORTUNITY': 'Opportunity Id (Sales Force)',
      'NAMEOPORTUNITY': 'Opportunity name (Sales Force)',
      'IDTYPERESULT':'result types',
      'NAM_USE_SWIFT':'User name',
      'TO_USE_SWIFT':'Total number of collaborators',
      'EMA':'User email',
      'PASS_USE_SWIFT':'User password',
      'CAT_RES':{
        '1':'Complete results',
        '2':'Basic results',
      },
      'PROYECTMANAGER': 'Project manager',
      'PROYECTMANAGER_MAIL': 'Project manager email',
      'CONFIGURE': 'Click here to configure',
      'INFOR': 'Info',
      'ADDPRODUCTS': 'Add products',
      'ADD': 'Add',
      'NAME_SURVEY':'Survey name:',
      'UPDATE_NAME_SURVEY':'Updating the name ',
      'LABELCONTRATADOS': 'Products in use',
      'PRODUCTOS': catalogos.productos,
      'PRODUCTOSTURQUIA': catalogos.productosTurquia,
      'CATEGORIAS': catalogos.categorias,
      'GETLISTAEMP': 'Loading registered companies list',
      'EDITAR': 'Edit company information',
      'LOGIN': 'Log In',
      'PAGINATOR_1': 'of',
      'PAGINATOR_2': 'companies',
      'TIMELINE': 'T.R. timeline',
      'PAQUETES': 'Packages',
      'ELIMINAR': 'Delete company',
      'CORREOMODIF': 'This product has email body changes',
      'CORREOMODIFMODAL': 'There are new email changes pending of validation in one or more products. Please check them',
      'CORREOMODAL_2': 'New email changes are currently pending validation',
      'MODIFBTN': 'Product settings',
      'INF_BTN': 'Product information',
      'INF_PROD_SEL': 'Product information',
      'VALIDMAIL_1': 'Validate changes',
      'VALIDMAIL_2': 'Validated email',
      'VALIDMAIL_3': 'Do you want to validate the changes made to the message?',
      'VALIDMAIL_4': 'The changes to the email were validated correctly',
      'VALIDMAIL_5': 'Reject changes',
      'VALIDMAIL_6': 'Do you want to reject the changes made to the message?',
      'VALIDMAIL_7': 'The changes to the email body were rejected. The default email template will be used instead',
      'VALIDMAIL_8': 'Rejected email',
      'VALIDMAIL_9': 'Enable editing to the company',
      'VALIDMAIL_10': 'Do you want to enable email editing to the company again?',
      'VALIDMAIL_11': 'The edition was enabled for the company',
      'VALIDMAIL_12': 'Edit mail',
      'VALIDMAIL_13': 'Now you can edit the email sent by the company',
      'SINCORREOS': 'There are no emails to validate',
      'FILEMANODS': 'File manager',
      'TEX-MENS-1':'The Company',
      'TEX-MENS-2':'no users',
      'FILEMAN_PRIV': 'Private Drive',
      'FILEMAN_PUB': 'Public Drive',
      'USUARIO':'User',
      'AL':'to',
      'SEN_EMAIL_REQ': 'Would you like to send the technical requirements email',
      'SEN_EMAIL_REQ_PROD': 'Be sure to send the technical requirements email',
      'ETIQUE_SEN_EMAIL_REQ_PROD': 'Mailing Technical Requirements',
      'EMAIL_REQ_PLACE':'Select a language',
      'EMAIL_REQ_INTRO':'Select a language to continue ',
      'WARN_SEN_EMAIL_REQ_PROD':'To continue you must select a language',
      'TOOLTI_SEN_EMA': 'Send mail',
      'ESTA_EMA_TRUE': '*Sent Mail',
      'ESTA_EMA_FALSE': '*Not sent mail',
      'SEN_EMAIL_MODAL': 'Sending email ......',
      'RTINFO': 'Technical requirements information',
      'TOOTI_RES_EMPR':'Results empresing',
      'WARNI_SELCT_CHECK':'To continue with the search it is mandatory to check at least one box',
      'REQ':{
        'BTNSI':'Yes',
        'BTNNO':'No',
        'MENSAJE1':'Do you want to active the technical requirements?',
        'MENSAJE2':'Do you want to deactive the technical requirements',
      },
      'EDITORMAILODS': {
        'OPCION_1': 'Activate email editor to this product',
        'OPCION_2': 'Automatic validation of changes',
        'OPCION_3': 'Activate requirements details on survey process',
        'OPCION_4': 'Activate survey validation for Focus Area',
        'OPCION_5': 'Allow to change application time',
        'OPCION_6': 'Allow extensions',
        'OPCION_7':'Chance successfuly on requirements details on survey process',
        'OPCION_8': 'Number of assignable reminders',
        'OPCION_9': 'Activate close date edition',
        'OPCION_10': 'Activate reopening of steps',
        'OPCION_11_ENTREGABLES': 'Show results of deliverables in Counting Portal',
        'OPCION_11_RANKING': 'Show certification results & ranking in Counting Portal',
        'OPCION_12':'Enable survey protection with user PINs',
        'OPCION_13':'Enable the random validation question',
        'OPCION_14':'Show Instrucctions Box in Survey App',
        'OPCION_15':'Show Support Box in Survey App',
        'OPCION_16':'Show User name in the Survey App',
        'MODAL_OP11_ON': 'The step reopening function was activated for this product',
        'MODAL_OP12_OF': 'The step reopening function was deactivated for this product',
        'MODAL_OP1_ON': 'Email editor for this product has been activated',
        'MODAL_OP1_OFF': 'Email editor for this product has been disabled',
        'MODAL_OP2_ON': 'Automatic changes validation has been activated for this product',
        'MODAL_OP2_OFF': 'Automatic changes validation for this product has been disabled',
        'MODAL_OP6_ON': 'Allowing rollovers for this product has been enabled',
        'MODAL_OP6_OFF': 'Allowing rollovers for this product has been deactivated',
        'MODAL_OP7_ON': 'The number of assignable reminders for this product has been changed',
        'MODAL_OP8_ON': 'Editing of the survey closing date was activated for this product',
        'MODAL_OP8_OFF': 'Editing the survey close date for this product has been disabled',
        'MODAL_OP11_ENTREGABLES_ON': 'The sample of deliverable results was activated',
        'MODAL_OP11_ENTREGABLES_OFF': 'The sample of deliverable results was deactivated',
        'MODAL_OP11_RANKING_ON': 'Certification & ranking results sample activated',
        'MODAL_OP11_RANKING_OFF': 'Sample of certification & ranking results were deactivated',
        'MODAL_PIN_ON':'Pin is enabled',
        'MODAL_PIN_OFF':'Pin is disabled',
        'MODAL_PRECONTROL_ON':'Random validation question was activated',
        'MODAL_PRECONTROL_OFF':'Random validation question is disabled',
        'MODAL_OP14_ON': 'Show the instruction box in the survey application is active',
        'MODAL_OP14_OFF': 'Displaying the instruction box in the survey application is deactivated',
        'MODAL_OP15_ON': 'Show support panel in the survey application was activated',
        'MODAL_OP15_OFF': 'Show support box in survey application deactivated',
        'MODAL_OP16_ON': 'Displaying the user name in the survey application is active',
        'MODAL_OP16_OFF': 'Displaying the user name in the survey application is disabled',
        'TITUOPTS': 'Options',
        'TITUCORRS': 'Emails left to validate',
        'SELLANG': 'Select a language from the list to view the email',
        'SELLANG_L': 'Select a language',
        'ASUNTO': 'Mail subject',
        'ASUNTOPILOTO': 'Pilot mail subject',
        'WAIT':'Saving change',
        'ULTD': 'Unlimited',
        'CLOUD_LEGACY': 'Activate updated version of file manager',
        'CUSTOM_TEXT_CERT': 'Activate multi-site certificate text',
        'CUSTOM_TEXT_CERT_EDIT': 'Edit the certificate text',
        'TEXT_SECC_CONF_VOIC': 'Show voice configuration section',
        'SAVED_CHANGES': 'The change was saved successfully',
        'CUSTOM_TEXT': {
          'TITULO': 'List the countries where the multi-site certificate has coverage',
          'SUBTITULO': 'Write the new text',
          'SUBTITULO2': 'Warning, if you change the text and click the OK button, the current text will be overwritten',
          'HINT': 'Certificate text',
          'OK': 'Accept',
          'CANCEL': 'Cancel',
          'SAVED_CHANGES': 'The text was saved correctly',
          'CURRENT_T1': 'Current multi-site text',
          'CURRENT_T2': 'The current multi-site text is very long, to view it click the Edit button',
        }
      },
      'ASOCIARCERTIFICAR':{
        'CHECK':'Associate culture audit with a certificate',
        'INPUT':'Certificate to be associated',
        'INPUT_2':'Product to associate',
        'CERTIFICAR':'Certify',
        'MEDIR':'Measure',
      },
      'LOG_SISTEMA':{
        'TITULO':'System Log',
        'BUSCADOR':'Search results',
        'PLACEHOLDER':'Search',
        'ACTUALIZAR':'Update log',
        'PAGINA':'Page',
        'CARGA':'Loading data...',
        'TABLA':{
          'IMAGEN':'Image',
          'IP':'Client IP',
          'USER':'User',
          'COMPANY':'Company',
          'PLATFORM':'Platform',
          'STATUS':'Status',
          'RESULT':'Result',
          'DATE':'Date',
        },
      },
      'LOG_SENDGRIND':{
        'TITULO':'SendGrid\'s Log',
        'OPCION':'Select an option:',
        'TOOLTIP':'Search status',
        'TABLA':{
          'USUARIO':'User',
          'EMAIL':'Email',
          'ASUNTO':'Subject',
          'ESTATUS':'Status'
        },
        'DIALOG_SENDGRIND':{
          'TITTULO':'Mailing Information',
          'TO':'To',
          'FROM':'From',
          'SUBJECT':'Subject',
          'HISTORIAL':'Mail History',
          'ESTATUS':'Status',
          'ABIERTO':'Times open:',
          'ULTIMO_EVENTO':'Last event:',
          'SIN_CORREOS':'Your email history is not available!',
          'BOTON':'Close',
          'NOTE':'NOTE: The date time/time shown in the list is set to local time in  ',
        },
      },
      'CONFIR_CAMBIOS_SECCION':'Currently the survey is already created,\n\n¿are you sure you want to make the changes? If you confirm?\n\n*generate the survey again',
      'MODAL_CAMBIOS_SECCION':'Updating sections',
      'TIT_MOD_AGRE_ENCU':'New survey process',
      'TEX_NAM_SUR':'Survey name:',
      'TEX_PLA_SUR':'Template selection',
      'BTN_AGRE_SUR':'Add',
      'PLA_TEX_NAM_SUR':'Survey name:',
      'PLA_TEX_PLA_SUR':'Template selection',
      'WARNI_NOT_SURV_NOM35':'Currently the survey has not been generated',
      'MODAL_CREAT_INFRA':'Infrastructure is being created, please wait',
      'MODAL_ERROR_INFRA':'An error occurred while creating the infrastructure',
    },
    'GESTORSTATUS': {
      'BOTACCESO': 'Products information',
      'TITULO': 'Acquired products',
      'PRODUCTOS':{
        'CERTIFICAR': 'Certify',
        'MEDIR': 'Measurement',
        'PULSE': 'Pulse Check',
        'FOCUS': 'Focus Area',
        'NUMPROD': 'Number of products: ',
        'BOTACCESO': 'See products',
        'NOPRODUCTOS': 'You have no acquired products'
      },
      'PRODSINFO': {
        'ADQUIRIDOS': 'Acquired products',
        'SELECCIONE': 'Select a product from the list to show its information'
      },
      'STATUS': {
        'LISTA': 'Steps list',
        'CURRENT': 'Step status',
        'INFO': 'This list shows the current status for each step of the certify process.\n\nYou may change the status from "Completed" to "Not completed" by clicking on a step slider.\n\nNote: Some step status may be changed only under certain conditions.',
        'NO': 'Not completed',
        'SI': 'Step completed',
        'TOOLTIP': {
          'HELP': 'Click here to know more',
          'SLIDER': 'Click here to change the status for this step'
        }
      }
    },

    'ALERTS': {
      'OK': 'OK',
      'ODSINSERTOK': 'The company was registered correctly',
      'ODSFAILINSERT': 'The register process failed, please try again',
      'COLPLETEFORM1': 'Please complete step 1',
      'COLPLETEFORM2': 'Please complete step 2',
      'COLPLETEFORM3': 'Please complete step 3',
      'COLPLETEFORM4': 'Please complete step 4',
      'COLPLETEFORM5': 'Please complete step 5',
      'ODSEXIST': 'The company is already registered in the system. The info was not stored',
      'MAIL':'¿You want to resend the mail to the different people in charge?',
      'RSPSI':'Sí',
      'RSPNO':'No',
      'LABEL01':'You already have a NOM 035 product',
      'FIELD':'Required link',
      'PASSWORD': {
        'LONGITUD': 'The password must be at least eight characters long',
        'MINUSCULAS': 'The password must have at least one lowercase letter',
        'MAYUSCULAS': 'The password must have at least one capital letter',
        'NUMEROS': 'The password must have at least one numeric character',
        'ESPCHARS': 'The password must have at least one special character, not alphanumeric',
        'VALIDACION': 'There was a problem validating the password, please type it again and try to create the user again'
      }
    },
    'TI_MANAGER': {
      'TITULO': 'IT Manager',
      'DESCRIPTION': 'Enter the data of the IT manager to send the necessary information and settings that must be executed before the application of the survey',
      'DATOS': 'Data',
      'NOMBRE': 'Name',
      'APELLIDOS': 'Last name',
      'EMAIL': 'E-mail',
      'TELEFONO': 'Telephone',
      'EXTENSION': 'Extension',
      'CELULAR': 'Cell-phone',
    },
    'PERFILES': {
      'CABECERA':{
        'TITULO': 'PROFILES CREATOR',
        'DESCRIP': 'Lorem ipsum dolor sit amet, consectetur adipisicing elit,'
      },
      'BOTONES':{
        'BOT1':{
          'TITULO': 'Company profile',
          'BOTON': 'Create'
        },
        'BOT2':{
          'TITULO': 'User profile',
          'BOTON': 'Admin'
        },
        'BACK': 'Back',
        'NEXT': 'Next',
        'RESET': 'Reset',
        'EDIT': 'Save'
      },
      'EMPRESA':{
        'WAIT': 'Wait...',
        'TITUHEAD': 'Company profile',
        'CLOUD': 'Private folder',
        'INFO': 'Create a profile for a company',
        'INFOMOD': 'You can modify the profile data of this company <b>(changes are saved automatically)</b>',
        'PDF':{
          'BOTONDESCARGA':'Download information in pdf',
          'FECHA':'Date: ',
          'HORA':'Time: ',
          'MODAL':'Generating file for download...',
        },

        'ACTUALIZARCA':{
          'ACTUALIZARCA':'Update Culture Audit',
          'ACTUALIZARCA_BRI':'Update Culture Brief',
          'ACTUALIZARCA_ACTIAN':'Update Action Plan',
          'CERRAR':'Close',
          'SUCCESS':'Culture Audit successfully updated',
          'SUCCESS_ACTION':'Plan action successfully updated',
          'ERROR':'Error, your Culture Audit does not have a certified product',
          'ERROR_ACTION':'Error, your Plan action does not have a certified product',
          'ACTUALIZAR_ICCA':'Update ICCA',
        },

        'ACTUALIZAR_BD':{
          'TITULO':'Instructions',
          'INSTRUCCIONES':{
            'INSTRUCCION_1':'Download the database of collaborators that I store within the platform.',
            'INSTRUCCION_2':'Download the template provided by the platform, and copy the data from your collaborator database to this template.',
            'INSTRUCCION_3':'Make the necessary modifications to your collaborators database.',
            'INSTRUCCION_4':'Once the modifications to your collaborator database are completed, delete your previous collaborator database.',
            'INSTRUCCION_5':'Click on the button to upload your updated collaborator database and click on accept.'
          },
        },

        'SECCIONES':{
          'SEC1': {
            'TITULO': 'Company info',
            'TITULOPDF': 'Company info ',
            'NOMEMP': 'Company name',
            'NOM': 'Name',
            'SECTORREQUIRED': 'Sector is required',
            'SUBSECTORREQUIRED': 'Sub-sector is required',
            'ANIOFU': 'Foundation year',
            'SALESFORCE': 'Salesforce ID',
            'CODE': 'Company ID',
            'SALES_REQUIRED': 'Salesforce ID is required',
            'CODE_REQUIRED': 'The company ID is required',
            'INSTITUTO': 'Institute',
            'INSTITUTO_REQUIRED': 'Institute is required',
            'COMPANY': 'Company',
            'COMPANY_REQUIRED': 'The name of the company is required',
            'CAMPO_INVALID': 'The field does not allow the following characters /*?"<>:\'',
            'COMPANY_ACOR': 'Company short name ',
            'MOD_INGRE_ACORT': 'To continue enter the short company name',
            'ACORT_REQUIRED': 'Company short name is required',
            'SEDE': 'Host country',
            'SEDE_REQUIRED': 'It is necessary to select the host country to continue',
            'PUBLICATION': 'List name',
            'PUBLICATION_REQUIRED': 'The name of the publication is required',
            'FUNDATION': 'Foundation year',
            'FUNDATION_REQUIRED': 'The foundation year of the company is required',
            'EMP_TC_REQUIRED': 'The number of full-time employees is required',
            'EMP_TP_REQUIRED': 'Please fill in the number of part-time employees',
            'TOTCOL_REQUIRED': 'Please fill in the total number of collaborators',
            'RANKING': 'Ranking',
            'RANKING_REQUIRED': 'Please select ranking',
            'TIPO': 'Range of employees',
            'TIPO_REQUIRED': 'Please select a range of employees',
            'MULTINACIONAL': 'Multinational',
            'MULTINACIONAL_REQUIRED': 'Please select if you are multinational',
            'ANIORANK_REQUIRED': 'Enter the list year',
            'REGION': 'Region',
            'REGION_REQUIRED': 'Enter your region',
            'PAIS': 'Country',
            'ESTADO': 'State, city or province',
            'NAM_RANKIN':'Ranking name',
            'TYP_RANKIN':'Type ranking',

            'OPTSI': 'Yes',
            'OPTNO': 'No',

            'EMP_TC': 'Full time-employees',
            'EMP_TP': 'Part time-employees',
            'TOTCOL': 'Number of employees',
            'ANIORANK': 'List year',
            'ETIQ_CATALOGOS':{
              'SECTOR': 'Select a sector',
              'SUBSECTOR': 'Select a sub-sector',
              'MULTIN': 'Multinational',
              'TIPO': 'Type (Rank or sector)',
              'REGION': 'Select a region'
            },
            'CATALOGOS':{
              'INSTITUTOS': catalogos.institutos,
              'SECTORES': catalogos.sectores,
              'RANKING': catalogos.ranking,
              'REGIONES': catalogos.regiones,
            }
          },
          'SEC2': {
            'TITULO': 'Cultural GO contact',
            'NOM': 'First name',
            'APE': 'Last name',
            'EMAIL': 'Email',
            'TEL': 'Phone number',
            'EXT': 'Extension',
            'CEL': 'Cellphone',

            'NOM_REQUIRED': 'Enter a name',
            'APE_REQUIRED': 'Enter your last name',
            'EMAIL_REQUIRED': 'Enter your email',
            'TEL_REQUIRED': 'Enter your phone',
            'EXT_REQUIRED': 'Enter an extension',
            'CEL_REQUIRED': 'Enter your cellphone'

          },
          'SEC3': {
            'TITULO': 'HR Director',
            'NOM': 'Full name',
            'EMAIL': 'Email',
            'TEL': 'Phone number',
            'EXT': 'Extension',
            'CEL': 'Cellphone',

            'NOM_REQUIRED': 'Enter a name',
            'EMAIL_REQUIRED': 'Enter your email',
            'TEL_REQUIRED': 'Enter your phone',
            'EXT_REQUIRED': 'Enter an extension',
            'CEL_REQUIRED': 'Enter your cellphone'

          },
          'SEC4': {
            'TITULO': 'IT contact',
            'NOM': 'Full name',
            'EMAIL': 'Email',
            'TEL': 'Phone number',
            'EXT': 'Extension',
            'CEL': 'Cellphone',
            'REGISTER': 'Register',

            'NOM_REQUIRED': 'Enter a name',
            'EMAIL_REQUIRED': 'Enter your email',
            'TEL_REQUIRED': 'Enter your phone',
            'EXT_REQUIRED': 'Enter an extension',
            'CEL_REQUIRED': 'Enter your cellphone'

          },
          'SEC5': {
            'TITULO': 'Deliverables',
            'ENTRE': 'Deliverable',
            'TIPO': 'Type'
          }
        },
        'MENSAJES':{
          'CARGABD': 'Upload BD',
          'STATUS': 'STATUS',
          'CORRECTO': 'The company profile was creater successfully',
          'ERROR': 'An error occurred while creating the company profile'
        }
      },
      'USUARIO':{
        'TITULO_LOGIN':'Select the user you want to login with',
        'MJS_COMPLETE_INFO': 'Please fill in the information.',
        'MSJ_INVALIDEMAIL': 'Please enter a valid Email.',
        'MSJ_SELECTCOMPANY': 'Please select a company',
        'REGISTER_SUCCESS': 'User registered successfully',
        'REGISTER_SUCCESS_SWIFT': 'User successfully registered, an email has been sent to your user for activation',
        'REGISTER_ERROR': 'Error, the user could not register please try again',
        'PRODUCT_REGISTEROK': 'Product registered correctly.',
        'PRODUCT_REGISTERPREVIOUS': 'Product previously registered.',
        'PRODUCT_REGISTERFAIL': 'Error registering product, please try again',
        'CERTIFICAR_EXISTENTE': 'The certified product already exists',
        'CERTIFICAR_NO_TERMINADO': 'To add the following product you must conclude with the certificate for the year',
        'CERTIFICAR_NO_EXISTENTE': 'To add the Pulsecheck Product you must acquire the certificate for the year',
        'PULSOS-COMPLETOS':'Currently you have the allowed pulses',
        'MSJ_SELECTYEAR': 'Please select a year',
        'MSJ_SELECTYEARRESULTS': 'Es necesario tener un producto tipo',
        'MSJ_34': 'Es necesario seleccionar un producto tipo Certificar',
        'MSJ_35': 'Es necesario seleccionar un producto tipo Medir',
        'MSJ_36': 'Es necesario seleccionar un producto tipo Forall',
        'MSJ_SELECTPRODUCT': 'Please select a product',
        'MSJ_SELECTTEMPLETE': 'Please select a template',
        'MSJ_SELECTEMAILTEMPLETE': 'Please select a email template',
        'SIN_USUARIO': 'You need to register a user for this company to be able to add this product',
        //'SIN_SURVEYTOKEN': 'You need to enter the survey token to associate to this product in order to assign it',
        'MISMOANIOCERTIFICAR': 'The product cannot be added, you already have a Certify product from the same year, select a different year and try again',
        'SIN_SURVEYTOKEN': 'The year of this product does not has a survey yet',
        'SIN_CERTIFICAR_ASOCIA': 'You still need to associate a certified product',
        'SIN_TABLEAUVER': 'You need to enter the results version to associate to this product in order to assign it',
        'SINRANKING': 'You need to select the ranking year for this product before continuing',
        'SINTIPORANK': 'You need to select the type of ranking for this product before continuing',
        'SINIDOPORTUNITY': 'You need to enter the opportunity ID for this product before continuing',
        'SINNAMEOPORTUNITY': 'You need to enter the opportunity name for this product before proceeding',
        'SINIDTYPERESULT': 'You need to enter the result type for this product before continuing',
        'SINPROYECTMANAGER': 'You need to enter the name of the project manager for this product before continuing',
        'SINCORREOPM': 'You need to enter the email of the project manager for this product before continuing',
        'EMAILNOVALIDO': 'The email of the project manager entered is not in the valid format, please check it and re-enter it correctly',
        'GUARDANDOPRODUCTO': 'The selected product is being added to the company, please wait a moment',
        'TOKENMODAL_1': 'This is the survey token of the newly added product',
        'TOKENMODAL_2': 'What do you want to do next?',
        'TOKEN_SI': 'Copy the token',
        'TOKEN_NO': 'Continue',
        'TOKEN_COPIADO': 'Survey token was copied to clipboard successfully',
        'ERROR1':'You already have a registered product this year',
        'TITUHEAD': 'User profile',
        'TITUCREARHEAD': 'Create user',
        'TITUBUSCARHEAD': 'Search user',
        'TITUBUSCAREMPRESA': 'Search company',
        'TITUUSERGPTWHEAD': 'Admin Users',
        'INFO': 'Profile for a user',
        'USUARIO': 'Email',
        'USE_NAM': 'User Name',
        'USUARIOREQUIRED': 'Email is required',
        'USUARIONAMEREQUIRED': 'Username is required',
        'CONTRAREQUIRED': 'The password is required',
        'longitud':'Minimum 10 characters',
        'letraMin':'One smallcase characters',
        'letraMayu':'One uppercase characters',
        'numeroPass':'One number',
        'caracterPass':'One special characters',
        'LEVELREQUIRED': 'Select a level',
        'CONTRA': 'Password',
        'COMPANY': 'Company',
        'NIVEL': 'Authorization Level',
        'NIVELES': catalogos.niveles,
        'GUARDA': 'Save',
        'TH-NOMEMPRE':'Company Name',
        'TH-USUARIO':'User',
        'TH-TUSUARIO':'User Type',
        'TH-ACCIONES':'Actions',
        'TH-LOGIN':'Login',
        'TH-INSTITUTO':'Institute',
        'ACC-DELET':'Delete User',
        'ACC-EDIT':'Edit User',
        'UPDATE-USER':'Updated correctly',
        'EXIST-USER':'Existing User',
        'ALERT-EDIT':'Are you sure to modify the user?',
        'USUARIO-T':'Usuarios',
        'CONFIRM_ELIMINAR_USU':'Are you sure you want to delete the user?',
        'INGR_ELIMINAR_USU':'<span>Enter the user marked in red in the text field  ',
        'INGR_ELIMINAR_USU.2':'</span>',
        'ERROR_ELIMINAR_USU':'The user entered does not match',
        'OK_ELIMINAR_USU':'User was correctly deleted',
        'PASSWORDSAFE': 'The password should be at least 8 characters long: at least 1 digit, at least 1 lowercase, at least 1 UPPER CASE, and at least 1 non-alphanumeric character',
        'PRODUCT_EXIST':'The product with selected date already exists',
        'WAR_ADD_NA_US':'Please enter the user name',
        'WAR_ADD_TOT_US':'Please enter the total number of collaborators',
        'WAR_ADD_EMA_US':'Please enter the user email',
        'WAR_ADD_PASS_US':'Please enter user password',
        'WAR_INCO_EMA_US':'The email entered is incorrect',
        'WAR_INCO_PASS_US':'The password is not in the allowed format',
        'MOD_SAV_US':'Saving user',
        'MENSAJES':{
          'CARGABD': 'Upload BD',
          'STATUS': 'STATUS',
          'CORRECTO': 'User registered successfully',
          'ERROR': 'An error occurred while creating the user profile'
        }
      }
    },
    'CONSULTARENCUESTA':{
      'TITULO': 'Consult survey',
      'HEADER': 'Select the institute',
      'INSTITUTOS': 'Institutes',
      'FILTRO': 'Filter',
      'FILTRO_EMPRESA':'Filter company:',
      'FILTRO_TI_EMPR_TOKEN':'Filter token survey / company type:',
      'SELECCIONFILTRO': 'Search for required information',
      'BOTON_DESCARGA_EXCEL': 'Download information in excel format',

      'CARGANDO': 'Loading information...',
      'NOMBRE_DE_EMPRESA': 'Name of the company',
      'TIPO_DE_EMPRESA':'Type of company',
      'FECHA_C': 'Date of creation',
      'SECTOR': 'Sector',
      'SUBSECTOR': 'Subsector',
      'TIPO_ENC': 'Type of survey',
      'PLANTILLA': 'Template',
      'CATALOGOSPRODUCTOS': catalogos.plantillas,
      'CATALOGOSNAMETH': catalogos.nameTHConsEncuesta,
      'TOKEN': 'Survey token',
      'ID_ENC': 'Survey ID',
      'ANIO': 'Year',
      'CORREOS_EN': 'Mail sent',
      'FECHA_A': 'Date of application',
      'FECHA_CR': 'Closing date',

      'MODAL_SUCCES': 'File downloaded correctly',
      'MODAL_WARNING': 'No institute selected',
      'VIZUENCU':'Display surveys',
      'SELE_AN_ENCU':'Seleccione un año',
    },
    'CONSULTAR_RT':{
      'TITULO':'Consult technical requirements',
      'HEADER': 'Select the institute',
      'INSTITUTOS': 'Institutes',
      'FILTRO': 'Filter',
      'SELECCIONFILTRO':'Search for the required company',
      'CARGANDO':'Loading information...',
      'NOMBRE_DE_EMPRESA':'Company Name',
      'FECHA_DE_EMPRESA':'Date created',
      'PRODUCTO':'Product Type',
      'TOKEN':'Survey token',
      'ESTATUS':'Status',
      '0':'Not started',
      '1':'In process',
      '2':'Finished',
      'ACCIONES':'Actions',
      'PRODUCTOS':catalogos.productos,
      'ELEMENTOS':'Items per page',
      'DE':'of',
      'SIGUIENTE':'Next',
      'ULTIMA':'Last page',
      'PRIMERA':'First page',
      'ANTERIOR':'Previous'

    },
    'PAQUETES':{
      'NOMBRES':{
        '1': 'SILVER package',
        '2': 'GOLD package',
        '3': 'PLATINUM package',
      },
      'TOOLTIP':{
        'CONFIG': 'Click to configure',
      },
      'MENSAJES': {
        'ADDOK': 'The package was successfully added to the company. Now you can configure the products of the selected package',
        'NOTOK': 'The package could not be added, there is already a package assigned to the specified year, try again choosing another option',
        'USURE_PROD': 'Do you confirm to configure this product with the chosen characteristics?',
        'PROD_ACTIVADO': 'This product is already activated',
        'ONLYONE': 'In this category you can only choose one type of product, Do you want to continue the process with this choice?',
        'NOYEAR': 'You have not selected the application year for the package',
        'NOPAQ': 'You have not selected the package to assign',
      },
      'PREVIO':{
        'INFO': 'You do not have a current product package active',
        'BOTONES':{
          'ADD': 'Add a package',
          'SEE': 'Consult a previous package',
          'CANCELAR': 'Cancel',
          'ADDPACK': 'Add package',
          'SI': 'Yes',
          'NO': 'No',
        },
        'STEPS': {
          '1': 'Select the package you want to assign to the company',
          '2': 'Select the application year for the package',
        }
      },
      'INFOPAQ':{
        'TITULO': 'Current package:',
        'APLICA': 'Application year:',
        'AVANCE': 'Current package configuration progress',
        'STATUS':{
          'TITULO': 'Status:',
          'OK_1': 'Complete configuration',
          'NOTOK_1': 'Incomplete configuration',
          'OK_2': 'Already activated',
          'NOTOK_2': 'Not activated',
          'ADICIONAL': 'Additional Products',
          'ADINFO': 'Note: Their addition is optional',
        },
        'BOTONES':{
          'ADD': 'Add product',
          'CANCELAR': 'Cancel',
          'SI': 'Yes',
          'NO': 'No',
          'BACK': 'Go back',
          'ADDONE': 'Add a product',
          'DETAIL': 'See details',
        },
        'CERTIFICAR':{
          'TITULO':{
            '1': 'You have not activated this product',
            '2': 'You have already activated this product',
            '3': 'This is a category, you can activate the following products:',
            '4': 'This product can be assigned more than once during the package lifespan',
          },
          'INSTRUC': 'Configure this product below',
          'TIPO': 'Select the type of product',
          'INFO':{
            'TITULO': 'Product information',
            'SECCIONES': 'Sections',
            'TIPO': 'Type',
            'TEMP': 'Selected template',
            'STATUS':{
              'TITULO': 'Actual status',
              '1': 'Not finished yet',
              '2': 'Finished',
            },
            'TABLA':{
              '1': 'Product',
              '2': 'Options',
            }
          }
        }
      }
    },
    'AUDITORIA-AUTOMATICA':{
      'TITULO': 'Automated Audit',
      'TABLA':{
        'TH-NOM-EMPRESA':'Company Name',
        'TH-NO-COLAB':'No. Collaborators',
        'TH-CONTESTADOS':'Answered',
        'TH-FALTANTES':'Missing',
        'TH-PROGRESO':'Progress',
        'TH-ACCIONES':'Actions',
        'MSJ-DETALLES':'See details',
      }

    },
    'RESULTA-AUDITO':{
      'TIEM-RES-TAB':'Time response collaborators',
      'RES-CONT-TAB':'Control responses',
      'RES-COMENT-TAB':'Comments responses',
      'TIEM-RES-TITULO':'Check the response time of the collaborators',
      'RES-CONT-TITULO':'Percentage of response to control questions',
      'RES-COMENT-TITULO':'Percentage of empty, repeated or repeated character comments',
      'RES-AGREGAR':'Adding a sample',
      'RES-SELECCIONAR':'Select sample',
      'RES-TEXTO1':'No sample has been created yet',
      'RES-TEXTO2':'Please select a sample to view the data',
      'INGRE-NOM': 'Enter the name of the sample',
      'SELEC-REG': 'Select the rules of the sample',
      'REGLAS':{
        '1': 'Collaborators who answered in less than 10 minutes',
        '2': 'Collaborators who answered all their items with a value of 5',
        '3': 'Collaborators who answered YES to the control question',
        '4': 'Collaborators who answered a random question incorrectly',
        '5': 'Collaborators who changed more than 10 answers',
      },

      'TABLA':{
        'TITULO':'Data of the collaborators in the sample',
        'NOMBRE':'Name',
        'TELEFONO':'Phone',
        'CELULAR':'Cellular',
        'CORREO':'Email address',
        'COMENTARIO':'Commentary',
      },
      'MODALES':{
        'GENERANDO':'Generating sample, please wait...',
        'GUARDANDO':'Saving comment, please wait...',
        'TITULO':'Saved comment',
        'CERRAR':'Close',
        'TITULO_INFORMACION':'Once you have added the comment the field cannot remain empty, the last data saved in it will be taken',
        'SUCCE-MUES':'The sample was correctly created',
        'WARNI-SINU':'No more users left to register',
        'WARNI-CONDI': 'Dont forget to put a name and select at least one rule',


      },
    },
    'DESCARGAR_ENCUESTA':{
      'NPS':'NPS',
      'REACTIVOS':'Statements',
      'CONTROL':'Control',
      'DEMOGRAFICOS':'Demographics',
      'ABIERTAS':'Open',
      'CA':'4ALL',
      'CODIGOPROYECTO':'Project code: ',
      'ANIOAPLICACION':'Year of implementation: ',
      'MENSAJE':'It is not possible to download the survey, because it has not yet been created',
      'ACEPTAR':'Accept',
      'TEXTODESCARGA':'Survey of ',
      'DESCARGARENCUESTA':'Download survey',
      'INFORMACIONYAVISO':'Survey Information and Privacy Notice',
      'SECCIONES':'Sections',
      'TIPOENC1':'Less 50',
      'TIPOENC2':'More 50',
      'MODAL':{
        'TITLE':'Languages list',
        'SUBTITLE':'Choose a language',
        'PLACEHOLDER':'Select',
        'BTNCLOSE':'Close',
        'BTNSELECT':'Accept',
        'MAS50':'More 50',
        'MENOS50':'Less 50',
        'TIPOENCUESTA':'Select an survey type',
      }
    },
    'UPDATE_COLABORATORS':{
      'UPDATE':'Update employee database'
    },
    'INFORT': {
      'TITULO': 'Technical requirements progress',
      'SINLANGS': 'You need to select the languages in this product to see the list of steps',
      'PASOS': {
        'PASO_1': 'Step list',
        'PASO_2': 'Questionnaire',
        'PASO_3': 'Record'
      },
      'LISTAPASOS': {
        'autentication': 'Survey authentication',
        'testAccess': 'Display test',
        'testEmail': 'Proof of email reception',
        'validationQ': 'Validation questionnaire',
        'requirements': 'Data privacy policy',
      },
      'STATUS': {
        'PEND': 'Pending',
        'DONE': 'Step completed',
      },
      'RESP': 'Reply sent',
      'NORESP': 'Unanswered'
    },
    'MODAL_CONSULT_INFRAESTRU':{
      'TITL':'Dedicated infrastructure:',
      'INSTRUC_1':'Do you wish to add dedicated infrastructure?',
      'LAB_SUBDOMINIO':'SubDomain',
      'WARN_CARACT':'The field does not allow the letter ñ, uppercase letters and special characters',
      'BTN_CONTI':'Continue',
      'SI':'Yes',
      'NO':'No',
      'MODA_IMPORT_SUBDOM':'To continue you must enter the subdomain',
    }
  }
};
